import svgPaths from "./svg-v00e3glb1b";

function Group() {
  return (
    <div
      className="absolute bottom-[39.15%] left-0 right-[71.81%] top-[24.93%]"
      data-name="Group"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 13 11"
      >
        <g id="Group">
          <path
            d={svgPaths.p16d34100}
            fill="var(--fill-0, white)"
            id="Vector"
          />
        </g>
      </svg>
    </div>
  );
}

function Group1() {
  return (
    <div
      className="absolute inset-[9.66%_0.03%_6.48%_52.79%]"
      data-name="Group"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 22 26"
      >
        <g id="Group">
          <path
            d={svgPaths.p23d0bf00}
            fill="var(--fill-0, white)"
            id="Vector"
          />
        </g>
      </svg>
    </div>
  );
}

function Group2() {
  return (
    <div
      className="absolute contents inset-[9.66%_0.03%_6.48%_52.79%]"
      data-name="Group"
    >
      <Group1 />
    </div>
  );
}

function Group3() {
  return (
    <div
      className="absolute bottom-[-0.04%] left-[7.02%] right-[32.52%] top-0"
      data-name="Group"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 28 31"
      >
        <g id="Group">
          <path
            d={svgPaths.p38e3bc80}
            fill="var(--fill-0, white)"
            id="Vector"
          />
        </g>
      </svg>
    </div>
  );
}

function Group4() {
  return (
    <div
      className="absolute bottom-[-0.04%] contents left-[7.02%] right-[32.52%] top-0"
      data-name="Group"
    >
      <Group3 />
    </div>
  );
}

export default function Frame() {
  return (
    <div className="relative size-full" data-name="Frame">
      <Group />
      <Group2 />
      <Group4 />
    </div>
  );
}
